var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3236 13.8832C13.6858 14.2434 14.2449 13.6875 13.8827 13.3351L10.9297 10.3909C11.9656 9.25119 12.5381 7.76915 12.5361 6.23297C12.5361 2.79544 9.72495 0 6.26807 0C2.81118 0 0 2.79544 0 6.23297C0 9.6705 2.81118 12.4659 6.26807 12.4659C7.82721 12.4659 9.26824 11.8943 10.3707 10.9468L13.3236 13.8832ZM0.786658 6.23297C0.786658 3.22611 3.25136 0.783036 6.26728 0.783036C9.29107 0.783036 11.7479 3.22611 11.7479 6.23297C11.7479 9.23983 9.29107 11.6829 6.26728 11.6829C3.25136 11.6829 0.786658 9.23983 0.786658 6.23297Z",
    fill: "#B8AFAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.e96499ec0e123975eb098f5c2de0e070.svg";
export { ForwardRef as ReactComponent };